import { useContext, useEffect } from 'react'
import { Booking } from 'features/bookings/types/bookings.types'
import { FieldValues, UseFormReset } from 'libs/form'
import { RentalItem } from 'features/rentals'
import { useBookingData } from '../../../hooks'
import { StoreSettingsContext } from 'store'

interface UsePopulateBookingProps {
	data: Booking | undefined
	rentals: RentalItem[] | undefined
	reset: UseFormReset<FieldValues>
}

export const usePopulateBooking = ({ data, rentals, reset }: UsePopulateBookingProps) => {
	const { paymentMethod, paymentStatus } = useBookingData()
	const storeCtx = useContext(StoreSettingsContext)
	const selectedRental = rentals?.find((rental) => rental.id === data?.rental)

	useEffect(() => {
		if (data) {
			const paymentStatusValue =
				data.payment.status === 'undefined' ? 'in_store' : data.payment.status
			const selectedPaymentStatus = paymentStatus.find(
				(status) => status.value === paymentStatusValue
			)
			const selectedPaymentMethod = paymentMethod.find(
				(method) => method.value === data.payment.method
			)

			let defaultRentalCommission = data.commission

			const rate = storeCtx?.storeSettings?.rates[0]

			if (!data.commission && data.rental) {
				defaultRentalCommission = selectedRental?.commission as string
			} else if (!data.commission && !data.rental && rate) {
				defaultRentalCommission = rate?.rate
			}

			reset({
				user: { label: data.user.email, value: data.user.pk },
				from: new Date(data.start_date),
				to: new Date(data.end_date),
				store_notes: data.store_notes,
				commission: defaultRentalCommission,
				payment: {
					status: selectedPaymentStatus,
					method: selectedPaymentMethod
				},
				booth: {
					value: data.booth.id,
					label: `#${data.booth.number} ${data.booth.booth_type.name}`
				},
				rental: {
					value: selectedRental?.id,
					label: `${selectedRental?.booth_type_name?.name} - ${selectedRental?.duration}`
				}
			})
		}
	}, [data, reset, selectedRental, storeCtx?.storeSettings?.rates[0]])
}
